import Plugin from '../core/Plugin';
import { PlayerEvent } from '../PlayerEvents';
import { removeFromParent, createElement, appendChild } from '../utils/Dom';

/**
 * 封面组件。 当前未使用video.poster属性
 *
 * @export
 * @class Poster
 * @extends {Plugin}
 */
export default class Poster extends Plugin {
  constructor() {
    super();
    this._allConfig = null;
  }

  init(opts = {}) {
    if (!opts['poster']) {
      return;
    }
    super.init(opts);
    this._allConfig = opts;
    this._createPoster(opts);
    this._handleCareEvent();
  }

  _createPoster(opts) {
    this.poster = createElement('img', {
      id: 'vh-posterImg',
      src: `${opts['poster']}`
    }, {
      style: 'width: 100%; height: 100%; position: absolute; top: 0; left: 0; z-index: 0; object-fit: cover'
    });
    appendChild(opts['id'], this.poster);
  }

  _handleCareEvent() {
    this.player.on(PlayerEvent.PLAYING, this.__onPlay.bind(this));
  }

  __onPlay() {
    this.poster.style.display = 'none';
  }

  static get type() {
    return 'plugin_poster';
  }

  destroy() {
    super.destroy();
    this.poster && removeFromParent(this.poster);
  }
}
